import { ApButtonTab } from '@alixpartners/ui-components';

import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  background: #ffffff;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
  padding: 24px;
  gap: 8px;
  box-sizing: border-box;
`;

export const Description = styled.div`
  margin-bottom: 4px;
`;

export const StyledButtonTab = styled(ApButtonTab)`
  && {
    min-height: 32px;
    height: 32px;
    border-radius: 4px;
    padding: 0 4px;
    font-size: 13px;
    font-weight: 400;
    color: #4a4a4a;
    width: 100%;
    text-align: left;
    justify-content: flex-start;
    background: transparent;
  }
  ${({ isSelected }) =>
    isSelected
      ? css`
          && {
            background: #dff0db;
          }
        `
      : ''}
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 17px;
  line-height: normal;
  color: #28292c;
`;
